import { ItemWithId } from 'components/table/types';
import { ColumnInstance } from 'react-table';

type Props<T extends ItemWithId> = {
  column: ColumnInstance<T>;
};

const CustomHeaderColumn = <T extends ItemWithId>({ column }: Props<T>) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()} className="w-150px">
        {column.render('Header')}
      </th>
    ) : (
      column.render('Header')
    )}
  </>
);

export { CustomHeaderColumn };
